import gql from "graphql-tag";

export const GET_MAILTEMPLATES = gql`
query mailTemplates(
	$type: MailTemplateType!
	$skip: Int
	$take: Int
	$where: MailTemplateFilterInput
	$order: [MailTemplateSortInput!]
	){
    mailTemplates(
    	type: $type
    	skip: $skip
		take: $take
		where: $where
		order: $order
    ) {
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        items {
          id,
          name,
          content
        }
    }
}
`;
